import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import PatientList from "../components/PatientList";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  referralAuthHistoryState,
}: ApplicationState) => ({
  referralAuthHistory:
    referralAuthHistoryState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);
